/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const TableOfContents = [
  ["path", { d: "M16 5H3" }],
  ["path", { d: "M16 12H3" }],
  ["path", { d: "M16 19H3" }],
  ["path", { d: "M21 5h.01" }],
  ["path", { d: "M21 12h.01" }],
  ["path", { d: "M21 19h.01" }]
];

export { TableOfContents as default };
//# sourceMappingURL=table-of-contents.js.map
